export const PROJECT_MODULES = [
  {
    key: "landing",
    level: 1,
    label: "Landing",
    shortLabel: "Landing",
    description: "Página institucional, datos del negocio, contacto y presencia online básica.",
    includes: ["Portada", "Información del negocio", "Contacto y WhatsApp"],
  },
  {
    key: "products",
    level: 2,
    label: "Productos",
    shortLabel: "Productos",
    description: "Suma catálogo, stock, precios y consulta de productos sobre la landing.",
    includes: ["Catálogo público", "Gestión de productos", "Consulta por WhatsApp"],
  },
  {
    key: "orders",
    level: 3,
    label: "Pedidos",
    shortLabel: "Pedidos",
    description: "Armado y seguimiento de pedidos para retiro o entrega, sin pago online obligatorio.",
    includes: ["Datos del comprador", "Retiro o envío", "Estados del pedido"],
  },
  {
    key: "ecommerce",
    level: 4,
    label: "E-commerce",
    shortLabel: "E-commerce",
    description: "Checkout online y cobros con la cuenta de Mercado Pago de cada cliente.",
    includes: ["Checkout", "Mercado Pago", "Webhook por proyecto"],
  },
  {
    key: "system",
    level: 5,
    label: "Gestión del negocio",
    shortLabel: "Gestión",
    description: "Caja, ítems operativos, inventario, gastos y contabilidad en un mismo lugar.",
    includes: ["Caja", "Ítems del negocio", "Inventario y contabilidad"],
  },
  {
    key: "stats",
    level: 6,
    label: "Estadísticas",
    shortLabel: "Estadísticas",
    description: "Visitas, recorridos, productos con más interés y ventas generadas desde la web.",
    includes: ["Visitantes", "Conversión", "Productos y ventas web"],
  },
  {
    key: "webpush",
    level: 7,
    label: "Notificaciones Web Push",
    shortLabel: "Notificaciones",
    description: "Alertas del funcionamiento de la web y campañas para quienes se suscriban.",
    includes: ["Avisos de pedidos", "Alertas de billing", "Campañas a visitantes"],
  },
];

export function normalizeProjectModules(modules = {}) {
  const normalized = {
    landing: modules?.landing !== false,
    products: modules?.products !== false,
    orders: modules?.orders === true,
    ecommerce: modules?.ecommerce === true || modules?.payments === true,
    system: modules?.system === true || modules?.invoicing === true,
    stats: modules?.stats === true,
    webpush: modules?.webpush === true,
  };

  if (normalized.products) normalized.landing = true;
  if (normalized.orders) {
    normalized.landing = true;
    normalized.products = true;
  }
  if (normalized.ecommerce) {
    normalized.landing = true;
    normalized.products = true;
    normalized.orders = true;
  }

  if (!normalized.landing) {
    normalized.products = false;
    normalized.orders = false;
    normalized.ecommerce = false;
  } else if (!normalized.products) {
    normalized.orders = false;
    normalized.ecommerce = false;
  } else if (!normalized.orders) {
    normalized.ecommerce = false;
  }

  return normalized;
}

export function applyModuleChange(currentModules, key, enabled) {
  const next = {
    ...normalizeProjectModules(currentModules),
    [key]: Boolean(enabled),
  };

  if (key === "landing" && !enabled) {
    next.products = false;
    next.orders = false;
    next.ecommerce = false;
  }
  if (key === "products") {
    if (enabled) next.landing = true;
    if (!enabled) {
      next.orders = false;
      next.ecommerce = false;
    }
  }
  if (key === "orders") {
    if (enabled) {
      next.landing = true;
      next.products = true;
    }
    if (!enabled) next.ecommerce = false;
  }
  if (key === "ecommerce" && enabled) {
    next.landing = true;
    next.products = true;
    next.orders = true;
  }

  return normalizeProjectModules(next);
}

export function serializeModulesForApi(modules = {}) {
  const normalized = normalizeProjectModules(modules);
  return {
    landing: normalized.landing,
    products: normalized.products,
    orders: normalized.orders,
    payments: normalized.ecommerce,
    ecommerce: normalized.ecommerce,
    invoicing: normalized.system,
    system: normalized.system,
    stats: normalized.stats,
    webpush: normalized.webpush,
  };
}

export function isProjectModuleEnabled(project, moduleKey) {
  return Boolean(normalizeProjectModules(project?.modules)[moduleKey]);
}

export const BILLING_PLAN_LABELS = {
  landing: "Landing",
  catalogo: "Catálogo",
  pedidos: "Pedidos",
  pro: "Pro",
  plus: "Plus",
  ecommerce: "Pro",
  sistema: "Plus",
};

export function normalizeProjectPlanCode(plan) {
  if (plan === "ecommerce") return "pro";
  if (plan === "sistema") return "plus";
  return BILLING_PLAN_LABELS[plan] ? plan : "catalogo";
}

export function modulesForPlan(plan) {
  const code = normalizeProjectPlanCode(plan);
  const base = {
    landing: true,
    products: false,
    orders: false,
    ecommerce: false,
    system: false,
    stats: false,
    webpush: false,
  };

  if (code === "landing") return serializeModulesForApi(base);
  if (code === "catalogo") {
    return serializeModulesForApi({ ...base, products: true, stats: true });
  }
  if (code === "pedidos") {
    return serializeModulesForApi({
      ...base,
      products: true,
      orders: true,
      stats: true,
      webpush: true,
    });
  }
  if (code === "pro") {
    return serializeModulesForApi({
      ...base,
      products: true,
      orders: true,
      ecommerce: true,
      stats: true,
      webpush: true,
    });
  }
  return serializeModulesForApi({
    ...base,
    products: true,
    orders: true,
    ecommerce: true,
    system: true,
    stats: true,
    webpush: true,
  });
}

export function activeModuleLabels(project) {
  const modules = normalizeProjectModules(project?.modules);
  return PROJECT_MODULES.filter((module) => modules[module.key]).map(
    (module) => module.label,
  );
}
